import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import GwProductFormModule from "../../../modules/gw-product/form";

const GwProductFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.gwProduct.detail.metaTitle")
    : t("pages.gwProduct.add.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/other-list",
          title: t("common.text.otherList"),
          isDisabled: true,
        },
        {
          link: "/gw-product",
          title: t("common.text.gwProduct"),
        },
        {
          link: `/gw-product/${id || "add"}`,
          title: id ? t("common.text.detail") : t("common.text.add"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <GwProductFormModule />
    </>
  );
};

export default GwProductFormPage;
